export const ANCHOR_TARGET_TO_DATA_ID: Record<string, string> = {
  "payment-method": "PAYMENT",
  "flight-summary": "FLIGHT",
  "stay-summary": "STAY",
  "traveler-info-card": "TRAVELER",
};

export const resolveAnchorElement = (target: string): HTMLElement | null => {
  const dataId = ANCHOR_TARGET_TO_DATA_ID[target] ?? target;
  return document.querySelector<HTMLElement>(`[data-id="${dataId}"]`);
};
